// extracted by mini-css-extract-plugin
export default {"aboutMe":"Property1Default_aboutMe__r+PDA","property1default":"Property1Default_property1default__CbPmq"};